import { slovenia2026 } from '../trips/slovenia-2026.js';

/** @typedef {{ itemKey: string, label: string, category?: string }} ChecklistItem */

/** Normalize DB/JSON rows to checklist item shape. */
export function normalizeChecklistItems(items) {
  if (!Array.isArray(items)) return [];
  return items
    .map((item) => ({
      itemKey: String(item.itemKey ?? item.item_key ?? '').trim(),
      label: String(item.label ?? '').trim(),
      category: String(item.category ?? 'altro').trim() || 'altro',
    }))
    .filter((item) => item.itemKey && item.label);
}

/** Default checklist from published plan (wizard or legacy Slovenia seed). */
export function defaultChecklistItems(plan) {
  const fromDb = plan?.checklist_items ?? plan?.checklistItems;
  if (Array.isArray(fromDb) && fromDb.length > 0) {
    return normalizeChecklistItems(fromDb);
  }
  if (plan?.sections?.whereToEat) {
    return slovenia2026.checklistItems;
  }
  return [];
}

/** Resolve checklist for a live instance (instance overrides plan defaults). */
export function resolveChecklistItems(plan, instance = null) {
  const fromInstance = instance?.checklist_items ?? instance?.checklistItems;
  if (Array.isArray(fromInstance) && fromInstance.length > 0) {
    return normalizeChecklistItems(fromInstance);
  }
  return defaultChecklistItems(plan);
}

export function makeChecklistItemKey(prefix = 'custom') {
  const rand =
    typeof crypto !== 'undefined' && crypto.randomUUID
      ? crypto.randomUUID().slice(0, 8)
      : String(Date.now()).slice(-8);
  return `${prefix}-${rand}`;
}
